
<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>

<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
      <mat-card-title>Calculo Presupuesto</mat-card-title>
    </mat-card-header-->
    <mat-card-content>

    <div id="fieldsContainer">
        <mat-accordion class="iconTitle" multi>
            <mat-expansion-panel #advancedPanel [expanded]="true" (opened)="advancedPanel.open()" hideToggle>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <mat-icon>find_in_page</mat-icon>Filtros
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div id="container" class="formControl">
                    
                    <div class="control">
                        <mat-form-field class="controlWidth">
                        <mat-label>Division</mat-label>
                        <mat-select [(ngModel)]="filterBudgetCalculation.divisionId" name="filterBudgetCalculation.divisionId">
                            <mat-option [value]="-1">Todas las areas</mat-option>
                            @for (division of divisions; track division.id) {
                            <mat-option [value]="division.id">{{ division.description }}</mat-option>
                            }
                        </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="control">
                        <mat-form-field class="controlWidth">
                        <mat-label>Area</mat-label>
                        <mat-select [(ngModel)]="filterBudgetCalculation.areaId" name="filterBudgetCalculation.areaId">
                            <mat-option [value]="-1">Todas las divisiones</mat-option>
                            @for (area of areas ; track area.id) {
                            <mat-option [value]="area.id">{{ area.description }}</mat-option>
                            }
                        </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="control">
                        <mat-form-field class="controlWidth">
                          <mat-label>% Aumento</mat-label>
                          <input matInput type="text" name="filterBudgetCalculation.percentageIncrease" [(ngModel)]="filterBudgetCalculation.percentageIncrease">
                        </mat-form-field>
                      </div>
                </div>
                <div id="buttonContainer">
                    <button mat-flat-button class="button" (click)="executeBudgetCalculation()">
                        <mat-icon>search</mat-icon>Consultar
                    </button>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</mat-card-content>
<mat-card-footer class="general-wf-card-footer">
</mat-card-footer>
</mat-card>
